/* eslint-disable */

class filterActu {

  constructor() {

    this.$allActus = document.querySelectorAll('.actualites-wrapper .card');
    this.$filtersWrapper = document.querySelector('.col-filters .ul-filter');

    // data-* key name
    this.cat = "cat";
    this.month = "month";
    this.year = "year";

    this.addEventListener();
    
  }

  addEventListener() {
    document.body.addEventListener('click', e => {
      this.handleFilterClick(e);
    })
  }

 
  handleFilterClick(e) {
    
    const isFilterWrapperClicked = this.$filtersWrapper.contains(e.target);
    if(isFilterWrapperClicked) {
      this.resetChanges();
      this.filterActus(e);
    }
  }

  filterActus(e) {

    this.$allActus.forEach( actu => {
      if(e.target.getAttribute(`data-${this.cat}`)) this.subFilter(e.target, actu, this.cat); 
      if(e.target.getAttribute(`data-${this.month}`)) this.subFilter(e.target, actu, this.month); 
      if(e.target.getAttribute(`data-${this.year}`)) this.subFilter(e.target, actu, this.year); 
    })
  }

  subFilter(target, item, dataKey) {
    if (item.getAttribute(`data-${dataKey}`) != target.getAttribute(`data-${dataKey}`)) {
      item.style.display = "none";
    }
  }


  resetChanges() {
    this.$allActus.forEach( actu => {
      if (actu.style.display === "none") actu.style.display = "block";
    })
  }
}

const pageActu = document.querySelector('body.template-actualites');

if (pageActu) {
  new filterActu();


  const toggleFilters = document.querySelector('.togglefilters');

  toggleFilters.onclick = e => {
    e.target.classList.toggle('clicked');
    document.querySelector('.ul-filter').classList.toggle('active');
  };


  const mobilePosition = document.querySelector('#banner-bis-grey');
  const movingElement = document.querySelector('.actualites-wrapper .col-filters');
  const desktopPosition = document.querySelector('.actualites-wrapper');

  const filtersContent = document.querySelector('.col-filters .content');



  const mediaQuery = '(max-width: 1199px)';
const mediaQueryList = window.matchMedia(mediaQuery);

// listen for changes
mediaQueryList.addEventListener('change', event => {
  if (event.matches) {
    mobilePosition.insertAdjacentElement('afterend', movingElement);
    filtersContent.classList.add('container');
  } else {
    desktopPosition.insertAdjacentElement('afterbegin', movingElement);
    filtersContent.classList.remove('container');
  }
})


if(mediaQueryList.matches) {
  mobilePosition.insertAdjacentElement('afterend', movingElement);
  filtersContent.classList.add('container');
}
else {
  desktopPosition.insertAdjacentElement('afterbegin', movingElement);
  filtersContent.classList.remove('container');
}

}


// WEBPACK FOOTER //
// ./scripts/actu.js